import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NGXLogger } from 'ngx-logger';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../../core/services/authentication.service';

@Component({
  selector: 'app-idle-popup',
  templateUrl: './idle-popup.component.html',
  styleUrls: ['./idle-popup.component.scss'],
})
export class IdlePopupComponent {
  popupTitle: string = 'Looks like you have been idle for a while!';
  popupDescription: string =
    'You will be logged out in less than 10 minutes. Click "Okay" to continue the session.';

  constructor(
    private dialogRef: MatDialogRef<IdlePopupComponent>,
    private authService: AuthenticationService,
    private log: NGXLogger
  ) {}

  okay() {
    this.authService
      .refreshToken()
      .pipe(first())
      .subscribe({
        error: () => {
          this.log.error('Error refreshing token');
        },
      });
    this.dialogRef.close();
  }
}
